module.exports = __webpack_public_path__ + "static/media/206-gallery17.ad7514ca.jpg";